export function iifeWrapper(body) {
  return "\n  (function () {".concat(body, "})();\n  ");
}